import { cn } from '@/lib/utils'

const CONDICIONES: Record<string, { label: string; className: string }> = {
  responsable_inscripto: {
    label: 'RI',
    className: 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
  },
  monotributo: {
    label: 'MONO',
    className: 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300',
  },
  exento: {
    label: 'EX',
    className: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  },
  consumidor_final: {
    label: 'CF',
    className: 'bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300',
  },
  no_responsable: {
    label: 'NR',
    className: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
  },
  monotributo_social: {
    label: 'MS',
    className: 'bg-teal-100 text-teal-700 dark:bg-teal-950 dark:text-teal-300',
  },
}

const CONDICION_TITLES: Record<string, string> = {
  responsable_inscripto: 'Responsable Inscripto',
  monotributo: 'Monotributista',
  exento: 'Exento',
  consumidor_final: 'Consumidor Final',
  no_responsable: 'No Responsable',
  monotributo_social: 'Monotributo Social',
}

interface CondicionFiscalBadgeProps {
  condicion: string | null | undefined
  className?: string
}

/**
 * Badge para mostrar la condición fiscal de forma abreviada
 */
export function CondicionFiscalBadge({ condicion, className }: CondicionFiscalBadgeProps) {
  if (!condicion) {
    return <span className="text-muted-foreground">-</span>
  }

  const config = CONDICIONES[condicion]

  if (!config) {
    // Fallback para condiciones no mapeadas
    return (
      <span
        className={cn(
          'text-[10px] px-1.5 py-0.5 rounded font-medium',
          'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
          className
        )}
      >
        {condicion.slice(0, 4).toUpperCase()}
      </span>
    )
  }

  return (
    <span
      className={cn(
        'text-[10px] px-1.5 py-0.5 rounded font-medium',
        config.className,
        className
      )}
      title={CONDICION_TITLES[condicion] || condicion}
    >
      {config.label}
    </span>
  )
}
